/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_1_Task_Countdown_OnceInputs */

const en_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 1 Countdown Focus`)
};

const ar_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمِل عَدًا تَنازليًا واحدًا للتركيز`)
};

const de_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Countdown-Fokus abschließen`)
};

const es_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 1 concentración de cuenta regresiva`)
};

const fr_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compléter 1 session Compte à rebours`)
};

const it_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 1 Concentrazione con il Timer`)
};

const ja_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カウントダウンフォーカスを1回完了`)
};

const ko_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스톱워치 집중 세션 1회 완료하기`)
};

const pt_br_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua 1 Foco com Contagem Regressiva`)
};

const ru_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершите 1 фокусировку с обратным отсчетом`)
};

const th_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสด้วยการนับถอยหลังให้เสร็จสิ้น 1 ครั้ง`)
};

const tr_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Geri Sayım Odaklanmasını Tamamla`)
};

const zh_cn_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 1 次倒计时专注`)
};

const zh_tw_phase_1_task_countdown_once = /** @type {(inputs: Phase_1_Task_Countdown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 1 次倒計時專注`)
};

/**
* | output |
* | --- |
* | "Complete 1 Countdown Focus" |
*
* @param {Phase_1_Task_Countdown_OnceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const phase_1_task_countdown_once = /** @type {((inputs?: Phase_1_Task_Countdown_OnceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_1_Task_Countdown_OnceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phase_1_task_countdown_once(inputs)
	if (locale === "ar") return ar_phase_1_task_countdown_once(inputs)
	if (locale === "de") return de_phase_1_task_countdown_once(inputs)
	if (locale === "es") return es_phase_1_task_countdown_once(inputs)
	if (locale === "fr") return fr_phase_1_task_countdown_once(inputs)
	if (locale === "it") return it_phase_1_task_countdown_once(inputs)
	if (locale === "ja") return ja_phase_1_task_countdown_once(inputs)
	if (locale === "ko") return ko_phase_1_task_countdown_once(inputs)
	if (locale === "pt_br") return pt_br_phase_1_task_countdown_once(inputs)
	if (locale === "ru") return ru_phase_1_task_countdown_once(inputs)
	if (locale === "th") return th_phase_1_task_countdown_once(inputs)
	if (locale === "tr") return tr_phase_1_task_countdown_once(inputs)
	if (locale === "zh_cn") return zh_cn_phase_1_task_countdown_once(inputs)
	return zh_tw_phase_1_task_countdown_once(inputs)
});